import StatusBadge from '@/components/ux/StatusBadge';

export function resolveInterviewDisplayStatus(row) {
  if (row.status === 'terminated') return 'terminated';
  // Check session-level decision first, then fall back to pipeline process-level decision
  const decStatus = row.decision?.status;
  const pfd = row.processFinalDecision;
  const isApproved = decStatus === 'approved' || pfd === 'hire';
  const isRejected = decStatus === 'rejected' || pfd === 'reject';
  if (row.status === 'completed' && isApproved) return 'accepted';
  if (row.status === 'completed' && isRejected) return 'rejected';
  return 'pending';
}

export default function InterviewStatusBadge({ row, className }) {
  return <StatusBadge status={resolveInterviewDisplayStatus(row)} className={className} />;
}
